<template>
  <CustomInput :field="{...deafult_input, readonly: readonly, value: value}" @update="update"/>
</template>
  
<script>
  import CustomInput from '@/components/inputs/CustomInput';
  export default {
    components: {
      CustomInput
    },
      
    name: 'NumericInput',
      
    props: {
      name: {},
      value: {},
      readonly: Boolean,
    },
      
    data: () => ({
      deafult_input: {
        id: '',
        label: '',
        required: false,
        value: '',
        readonly: false,
        cols: 4,
        class: null,
        component: 'NumericInput',
        placeholder: "",
      }
    }),
      
    computed: {
    },
      
    mounted() {
    },
      
    methods: {
      update(value) {
        this.$emit('update',value);
      }
    },
  }
</script>